module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "已上课程"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "contentchild",
    attrs: {
      "infinite-scroll-disabled": "disable",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.arrayData), function(obj, index) {
    return _c('VCoureseShowCell', {
      key: index,
      attrs: {
        "obj": obj
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState != 1),
      expression: "loadingState != 1"
    }],
    staticClass: "bottom"
  }, [_c('mt-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState == 2),
      expression: "loadingState == 2"
    }],
    attrs: {
      "type": "fading-circle",
      "color": "#cba164"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.stateText)
    }
  })], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "goBack"
  }, [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec371fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Myrecord/CompletedCourse.vue
// module id = 778
// module chunks = 1